module.exports = __webpack_public_path__ + "static/img/11.67019f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/sp/11.png
// module id = bDeD
// module chunks = 0